module.exports = __webpack_public_path__ + "img/job-1.773c2fb7.png";